import React from 'react';
import { Box, Divider, Theme, withStyles } from '@material-ui/core';

export const ContainerBox = withStyles(() => ({
  root: {},
}))(Box);

export const PaginationWrapperBox = withStyles(({ spacing }) => ({
  root: {
    marginTop: spacing(2),
  },
}))(Box);

export const HorizontalLine = withStyles(({ palette, spacing }: Theme) => ({
  root: {
    backgroundColor: palette.grey[200],
    height: 1,
    margin: spacing(2, 0),
  },
}))((props) => <Divider {...props} />);
